import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";

// Reads public runtime feature flags from GET /config.
// Phase 0: only `webrtc_enabled` (default false). Kept isolated so the live relay
// Session flow is never affected until a later phase opts into it.
export function useFeatureFlags() {
  const [flags, setFlags] = useState({ webrtc_enabled: false });
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get("/config")
      .then((r) => { if (alive) setFlags(r.data || {}); })
      .catch(() => {})
      .finally(() => { if (alive) setLoaded(true); });
    return () => { alive = false; };
  }, []);

  return { flags, loaded };
}
